<template>
  <div class="dropdown">
    <button
      class="btn btn-primary dropdown-toggle"
      type="button"
      id="send-invoice-button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      Factuur versturen
    </button>

    <div class="dropdown-menu" aria-labelledby="send-invoice-button">
      <button type="button"
              class="dropdown-item"
              v-for="email in senders"
              :href="email.url"
              :key="email.type"
              target="_blank"
              @click="send(email)"
      >Stuur {{ email.type }}
      </button
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: ["senders"],
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    async send(email) {
        if (!confirm("Wilt u zeker de factuur versturen?")) {
            return;
        }

      this.isLoading = true;

      const {
        data: { message, invoice },
      } = await axios.get(email.url);

      if (message === 'success') {
        this.$emit('mailSend', { ...email, invoice });
      }
    },
  }
};
</script>
